import { render, staticRenderFns } from "./UserTouchPerformance.vue?vue&type=template&id=21906270"
import script from "./UserTouchPerformance.vue?vue&type=script&lang=js"
export * from "./UserTouchPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports